import React, { Component } from 'react';
import ConversationHeader from './components/ConversationHeader';
import ConversationList from './components/ConversationList';
import Conversation from './containers/Conversation';
import EmptyConversation from './components/EmptyConversation';
import WaitForState from '../WaitForState';
import { withUser } from '../../utility/withUser';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { addMessage } from '../../actions/messages';
import { getConversation } from '../../utility/conversation';

/**
 * Component for showing conversation list.
 *
 * @extends React.Component
 */
class ConversationOverview extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      conversation: null,
    }
  }

  /**
   * Handle when a conversation has been updated.
   */
  handleConversationUpdate = () => {
    this.setState({conversation: null});
  }

  /**
   * Fetch a conversation from the supplied id.
   */
  fetchConversation = () => {
    window.clearTimeout(this.updateTimeout);
    if (!this.props.conversationId) {
        return;
    }
    getConversation(this.props.conversationId, this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af samtale. Prøv venligst igen senere.', 'danger'));
      }

      response.json().then((data) => {
        this.setState({conversation: data});
      });

      // Update conversation every 30 seconds.
      window.clearTimeout(this.updateTimeout);
      this.updateTimeout = window.setTimeout(() => {
        this.fetchConversation();
      }, 30000);
    });
  }

  /** @inheritdoc */
  componentDidMount = () => {
    if (this.props.conversationId) {
      this.fetchConversation();
    }
  }
  /** @inheritdoc */
  componentDidUpdate = () => {
    if (this.props.conversationId && this.state.conversation === null) {
      this.fetchConversation();
    }
  }
  /** @inheritdoc */
  componentWillReceiveProps = (props) => {
    if (props.conversationId && (this.props.conversationId !== props.conversationId || this.state.conversation === null)) {
      this.setState({conversation: null});
    }
  }
  /** @inheritdoc */
  componentWillUnmount = () => {
    window.clearTimeout(this.updateTimeout);
  }

  /** @inheritdoc */
  render() {
    // If we are passed a conversation id, we have to render a bit differently.
    if (this.props.conversationId) {
      return (
        <WaitForState state={this.state}>
          { this.state.conversation && (
            <div>
              <ConversationHeader active={this.state.conversation.status === 'closed' ? 'archived' : (this.state.conversation.advisor_id === this.props.user.id ? 'mine' : (this.state.conversation.advisor_id === null ? 'open' : 'ongoing'))} />
              <div className="row">
                <ConversationList filter={this.state.conversation.status === 'closed' ? 'archived' : (this.state.conversation.advisor_id === this.props.user.id ? 'mine' : (this.state.conversation.advisor_id === null ? 'open' : 'ongoing'))} />
                <Conversation conversation={this.state.conversation} onConversationUpdate={this.handleConversationUpdate} />
              </div>
            </div>
          )}
        </WaitForState>
      );
    } else {
      return (
        <div>
          <ConversationHeader active={this.props.filter} />
          <div className="row">
            <ConversationList filter={this.props.filter} />
            <EmptyConversation />
          </div>
        </div>
      );
    }
  }
}

export default withRouter(withUser(connect()(ConversationOverview)));



// WEBPACK FOOTER //
// ./src/components/ConversationOverview/index.js